import "./Promo.scss";
import flyer from "../../Assets/flyer.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Whatsapp } from "../../Assets/svg/whatsapp.svg";
const Promo = () => {
  const pointData = {
    poin1: [
      "Siap Huni",
      "Subsidi DP",
      "Free PPN 100%",
      "Free Biaya SHM, BPHTB, AJB",
      "Free Subsidi KPR All in One",
      "Free Sepeda Listrik",
      "Free Membership Clubhouse 2 tahun",
      "Free Canopy",
      "Free Smart Door Lock",
    ],
    // poin2: [
    //   "BONUS AC TIAP KAMAR",
    //   "VOUCHER FURNISH 50 JUTA*",
    //   "GRANDPRIZE IONIQ 5",
    // ],
  };
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281220003574&text=Halo+Lenny,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20(Promo%20Keseluruhan)%20The%20Lagoon%20Park%20Bukit%20Golf%20Riverside?%20http://marketingbukitgolfriverside.com/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  return (
    <section id="promo" className="section-promo">
      <div className="container">
        <div className="flyer">
          <img src={flyer} alt="promo flyer" />
        </div>
        <div className="highlights">
          <h4>PROMO KESELURUHAN BUKIT GOLF RIVERSIDE</h4>
          <div className="highlights-bottom">
            <div className="msg-hook">
              <div className="container-point">
                {pointData.poin1.map((item, index) => (
                  <div className="point-item" key={index}>
                    <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              {/* <div className="container-point">
                {pointData.poin2.map((item, index) => (
                  <div className="point-item" key={index}>
                    <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div> */}

              <div className="container-btn">
                <div className="term">*T&C apply</div>
                <button onClick={waOpen} className="btn">
                  <Whatsapp className="icon" />
                  CONTACT US
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Promo;
